import { useEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import { DataContextContractual, DataContext } from "../../contextData/contextData";
import { modalCargando } from "../../components/ui/sweetAlerts";
import { useSolicitudesCurso } from "./useSolicitudesCurso";
import { ModalContractuales } from "../modalForm/modalForm";
import { customStyles, paginationComponentOptions } from "../../utils/Constants";

export const SolicitudesEnCurso = () => {
  const { traerListado, objModal, visible, hideModal } = useSolicitudesCurso();
  const { dataListado } = useContext(DataContextContractual);
  const { setNombreMenuu } = useContext(DataContext);

  useEffect(() => {
    setNombreMenuu("Solicitudes en curso");
    modalCargando("Cargando datos...");
    traerListado();
  }, []);

  return (
    <>
      <ModalContractuales data={objModal} show={visible} hideModal={hideModal} tamanio="xl" />
      <div className="d-flex align-items-center flex-column">
        <div className="col col-12 col-lg-10 px-4">
          <DataTable
            data={dataListado.arrData}
            columns={dataListado.id_columnas}
            customStyles={customStyles}
            dense
            noHeader
            pagination
            noDataComponent="No se encontraron registros"
            paginationComponentOptions={paginationComponentOptions}
          />
        </div>
      </div>
    </>
  );
};
